import { env } from './env';

const siteConfig = {
	siteName: 'Zezamii',
	footerText: 'Zezamii Pty Ltd. - ' + env.appEnv,
	enableAnimatedRoute: false,
	mainServerBaseDomain: '', // base url for the main Backend server.
	// Function to get the correct domain based on environment
	getApplicationServerBaseDomain: (environment) => {
		switch (environment) {
			case 'development':
				return 'dev.api.zezamii.com';
			case 'staging':
				return 'dev.api.zezamii.com';
			case 'production':
			default:
				return 'df.api.zezamii.com';
		}
	},
	// Keeping static property for backward compatibility
	applicationServerBaseDomain: 'df.api.zezamii.com', //WIP - DO NOT INCLUDE HTTP:// OR HTTPS:// IN THE URL. e.g.value "dte.com "
	// Public guest booking portal (pass-portal PWA) base domain — env-overridable; never hardcode the
	// domain in components. No scheme / trailing slash. buildGuestUrl (library/helpers/bookingUrl) wraps it.
	// Points at the AZURE host (passes.*), not the legacy Vercel deployment (pass.*): only the Azure
	// App Service (zpPrdDaypass) carries BOOKING_PLATFORM_URL/BOOKING_SVC_TOKEN_PUBLIC, so only it
	// resolves `/p/:org/:site/:resource` against this platform's /v5/booking-public boundary. A QR or
	// share link aimed at pass.zezamii.com would resolve against the legacy Vercel data store instead.
	getPassPortalBaseDomain: () => env.passPortalDomain,
	// Day-pass guest portal base — the same Azure app as the booking portal above (one Next.js app
	// serves both booking modes off `/p/:org/:site/:slug`), kept as a SEPARATE knob so day-pass links
	// can be pointed elsewhere independently. Env-overridable; no scheme / trailing
	// slash. buildDayPassUrl (library/helpers/bookingUrl) wraps it.
	getDayPassPortalBaseDomain: () => env.dayPassDomain,
	google: {
		analyticsKey: 'UA-xxxxxxxxx-1'
	},
	dashboard: '/access',
	version: '3.1.1'
};
export default siteConfig;
